// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper__JxbrM","tableGeneral":"ReportsTable_tableGeneral__t2HMn","tableGeneralHeader":"ReportsTable_tableGeneralHeader__Mrv9M"};